/** `K7QP2M4X` -> `K7QP-2M4X`. */
export function formatPairingCode(code: string): string {
  return code.length === 8 ? `${code.slice(0, 4)}-${code.slice(4)}` : code
}

/** The payload the app's QR scanner understands. */
export function pairingDeepLink(pairingId: string, code: string): string {
  return `condi://web-login?p=${encodeURIComponent(pairingId)}&c=${encodeURIComponent(code)}`
}

/** `m:ss` countdown label. */
export function formatCountdown(totalSeconds: number): string {
  const s = Math.max(0, totalSeconds)
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
}
